import * as React from "react";
const CloseIcon = ({
  width = 32,
  height = 32,
  color = "#231F20",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.2269 3.03068C5.18924 4.25645 6.9939 5.73768 8.59725 7.43861C10.268 9.07021 11.7413 10.9084 12.9843 12.9125C12.9944 12.9246 13 12.9402 13 12.9562C13 12.9723 12.9944 12.9878 12.9843 13C10.5487 10.5849 8.00434 8.14407 5.45506 5.79078C4.63 4.99262 3.80994 4.17901 3.04417 3.2933C3.01744 3.26287 3.00178 3.22356 3.00014 3.18233C2.9985 3.1411 3.0109 3.10059 3.03512 3.06795C3.05935 3.03531 3.09388 3.01264 3.13258 3.00394C3.17128 2.99524 3.2117 3.00106 3.24668 3.02038L3.2269 3.03068Z"
      fill={color}
    />
    <path
      d="M12.982 3.26012C10.7453 5.9447 8.04439 8.1285 5.57556 10.5446C4.74109 11.3397 3.90663 12.1296 3.10673 12.9762C3.09691 12.9892 3.08257 12.9976 3.06683 12.9996C3.05108 13.0015 3.03527 12.9968 3.02283 12.9866C3.01039 12.9763 3.00226 12.9613 3.0004 12.9448C2.99855 12.9284 3.00312 12.9118 3.01294 12.8988C4.87938 9.89929 7.39751 7.39541 9.97497 5.07737C10.2219 4.89152 13.3524 2.16047 12.9672 3.26012H12.982Z"
      fill={color}
    />
  </svg>
);
export default CloseIcon;
